import { useState, useEffect } from 'react';
import axios from 'axios';

const apiParkingBase = process.env.BUN_PUBLIC_PARKING_API_BASE;

interface FormFieldConfig {
    id: number;
    parking_location_id: number;
    form_type: string;
    field_name: string;
    is_enabled: boolean;
}

export function useFormFieldConfigs(locationHash: string | null, formType: 'resident' | 'company') {
    const [fieldConfigs, setFieldConfigs] = useState<FormFieldConfig[]>([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!locationHash) {
            setLoading(false);
            return;
        }
        axios.get<FormFieldConfig[]>(`${apiParkingBase}/api/public/form-field-configs`, {
            params: { locationHash, formType }
        })
        .then(res => setFieldConfigs(res.data))
        .catch(console.error)
        .finally(() => setLoading(false));
    }, [locationHash, formType]);

    const isFieldEnabled = (fieldName: string) => {
        const config = fieldConfigs.find(f => f.field_name === fieldName);
        return config ? config.is_enabled : true;
    };

    return { isFieldEnabled, loading };
}

